import i18n from "i18next"
import { initReactI18next } from "react-i18next"

// Importamos los archivos JSON
import en from "./locales/en/translation.json"
import es from "./locales/es/translation.json"

const getInitialLanguage = () => {
  const queryLang =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("lang")
      : null
  const persistedLang =
    typeof window !== "undefined"
      ? localStorage.getItem("lang")
      : null

  if (queryLang && ["es", "en"].includes(queryLang)) {
    return queryLang
  }

  if (persistedLang && ["es", "en"].includes(persistedLang)) {
    return persistedLang
  }

  const browserLang =
    typeof navigator !== "undefined"
      ? navigator.language?.toLowerCase()
      : "es"

  return browserLang?.startsWith("en") ? "en" : "es"
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es }
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: { escapeValue: false }
})

export default i18n
